import { toastError, toastSuccess } from 'partial/components/react-geek-toast';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  createCategory,
  createContent,
  getCategories,
  getContents,
  showCategory,
  updateContent,
} from './actions';

export const useCategoryList = (filter) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-category-list', filter],
    queryFn: getCategories,
    retry: false,
    keepPreviousData: true,
  });
  const data = (raw?.data?.data || []).concat([
    {
      created_at: '',
      id: 'top-ten-agency',
      name: 'Top Agencies',
      slug: 'top-ten-agency',
      updated_at: '',
    },
    {
      created_at: '',
      id: 'top-ten-sender',
      name: 'Top 10 Sender Names',
      slug: 'top-ten-sender',
      updated_at: '',
    },
    {
      created_at: '',
      id: 'graph-data',
      name: 'Graph Data',
      slug: 'graph-data',
      updated_at: '',
    },
    {
      created_at: '',
      id: 'balance-count',
      name: 'Balance Count',
      slug: 'balance-count',
      updated_at: '',
    },
  ]);
  const meta = raw?.data?.meta;
  return [isLoading, data, meta];
};

export const useCreateCategory = (cb) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(createCategory, {
    onSuccess: () => {
      queryClient.invalidateQueries('get-category-list');
      toastSuccess('Successfully created category!');
      if (typeof cb === 'function') cb();
    },
    onError: (err) => {
      toastError(err?.response?.data?.message);
      if (typeof cb === 'function') cb();
    },
  });
  return [isLoading, mutate];
};

export const useShowCategory = (id) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['show-category', id],
    queryFn: showCategory,
    retry: false,
    keepPreviousData: true,
    enabled: !!id,
  });
  const data = raw?.data?.data;
  return [isLoading, data];
};

export const useContentList = (id, filter) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-content-list', id, filter],
    queryFn: getContents,
    retry: false,
    keepPreviousData: true,
    enabled: !!id,
  });
  const data = raw?.data?.data;
  const meta = raw?.data?.meta;
  return [isLoading, data, meta];
};

export const useCreateContent = (cb) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(createContent, {
    onSuccess: () => {
      queryClient.invalidateQueries('get-content-list');
      toastSuccess('Successfully created content!');
      if (typeof cb === 'function') cb();
    },
    onError: (err) => {
      toastError(err?.response?.data?.message);
      if (typeof cb === 'function') cb();
    },
  });
  return [isLoading, mutate];
};

export const useUpdateContent = (cb) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(updateContent, {
    onSuccess: () => {
      queryClient.invalidateQueries('get-content-list');
      toastSuccess('Successfully updated content!');
      if (typeof cb === 'function') cb();
    },
    onError: (err) => {
      toastError(err?.response?.data?.message);
      if (typeof cb === 'function') cb();
    },
  });
  return [isLoading, mutate];
};
